import "./Cards.css"

const Card = props => {
    return <div className={"grid-card"}>
        {props.children}
    </div>
};

export default Card;